import { gql } from '@apollo/client';

/**
 * 「站点作为 A」的 AB 映射提交（2.2 需求点2）：把当前编辑的站点整体映射到目标站点 B。
 *
 * <p><b>⚠️ 与 `saveStationAbMappings` 方向相反</b>：那条是「错误地址 → 当前站点」(当前站点当 B)，
 * 这条是「当前站点 → 目标站点」(当前站点当 A，整站搬走)。
 *
 * <p>全选且通过全部闸门时会**一并退役 A 站点**并把存量单重投到 B —— 不可逆，
 * 提交前必须先走 `previewStationAbRetire` 让运营确认。
 */
export const RESOLVE_STATION_AS_AB_MAPPING = gql`
  mutation ResolveStationAsAbMapping($input: ResolveStationAbMappingInput!) {
    resolveStationAsAbMapping(input: $input)
  }
`;

export interface ResolveStationAbMappingInput {
  /** A 站点 id：正在编辑的这个站点，它的地址将被映射走。 */
  sourceCooperationWarehouseId: number;
  /** 实际上门 B 站点 id。 */
  targetBCooperationWarehouseId: number;
  /**
   * A 站点所属 hub。
   *
   * <p>⚠️ **必传**：api-server 的 `@RequireResourceAndWarehouse` 按字段名反射取它做仓库维度鉴权，
   * 取不到会以 `WAREHOUSE_ID_REQUIRED` 拒绝整个请求。业务上后端不依赖它（自己按站点反查 hub）。
   */
  warehouseId: number;
  mappings: Array<{
    contactName?: string | null;
    contactPhone?: string | null;
    channelId?: number | null;
  }>;
  /** 是否已勾选 A 站点的全部维度；true 才会评估整站作废。 */
  fullySelected: boolean;
}

export interface ResolveStationAsAbMappingResponse {
  resolveStationAsAbMapping: boolean;
}
